import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h3
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
            color: "black",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h3>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Carbon is a foundational element within the Earth system, forming
              the structural framework of compounds containing energy that
              sustains bio-geo-chemical processes (Richle 2023, p. 3). Carbon
              occurs in diverse forms (as elements, compounds etc.) and
              reservoirs (carbon sink in plants, sediments, etc.), intricately
              distributed and consistently exchanged among the four major
              spheres of the earth system (Ramachandra and Bharath 2020, p.
              2759). Biogeochemical mechanisms govern carbon transition from one
              reservoir to another, and insights into the process are crucial
              for mitigating carbon dioxide (CO<sub>2</sub>) emissions and
              climate change (Ussiri and Lal 2017, p. 61).
            </p>
            <p>
              Land degradation due to unregulated developmental activities with
              the sustained human activities leading to deforestation, biomass
              burning, pollution in aquatic environments, and the burning of
              fossil fuel in transportation, electricity manufacture, industrial
              processes, and agricultural practices along with the uncontrolled
              rapid urban development has been contributing to the global carbon
              cycle, which is altering previously inert carbon reserves (Tyrrell
              et al. 2012, p. 77; Ramachandra et al. 2015, p. 474).
              Consequently, the concentrations of greenhouse gases in the
              atmosphere and their influence have progressively increased (Lal
              2008, p. 815), particularly since the Industrial Revolution in
              1850, with rapid growth in the human population. Globally, the
              greenhouse gas (GHG) footprint has been continuously increasing,
              with 72% of the resulting carbon dioxide (CO<sub>2</sub>)
              significantly influencing global warming and consequent climate
              modifications (Yoro and Daramola 2020, p. 3). These changes have a
              distinct impact on the subsistence and livelihood of the people
              due to the degradation of vital ecosystem services such as
              ecosystem productivity, soil fertility, carbon storage, and water
              retention capacity (Ramachandra and Bharath 2021, p. 53). The
              leading international forums have engaged in extensive
              deliberations on global climate change and have reached a
              unanimous consensus to reduce carbon emissions, aiming to attain
              global carbon neutrality by the middle of this century while also
              striving to cap the potential increase in global temperatures at a
              maximum of 1.5 &deg;C (UNFCC 2021).
            </p>
            <p>
              Forest ecosystems sequester significant amount &nbsp;(45%) of
              carbon during photosynthesis and contribute about 50% of net
              ecosystem production (Bonan 2008, p. 1444). These ecosystems play
              a pivotal role in mitigating carbon footprint by sequestration of
              atmospheric carbon and retard global warming and associated
              climatic changes (Ramachandra and Bharath 2019, p. 2759). Forests
              also serve as extensive terrestrial carbon repositories and hold a
              pivotal position within the carbon cycle (C-cycle). The
              significance of forests lies in their capacity to sequester
              atmospheric carbon within components such as above-ground biomass
              (AGB), below-ground biomass (BGB), and soil organic carbon (SOC)
              (Leuschner et al. 2013, p. 1174; Raha et al. 2013, p. 120).
              Sequestration of carbon (C) in ecosystems refers to the
              assimilation of atmospheric CO<sub>2</sub> and storage in
              ecosystem constituents, which increase its mean residence time
              (MRT) and minimize sinks of re-emission (Lal et al. 2015), which
              is most effective in the native and intact forests (Ramachandra
              and Bharath 2019, p. 2754).
            </p>
            <p>
              Alterations in the landscape structure with mismanagement have
              resulted in soil degradation, contributing to the emission of
              greenhouse gases, which include carbon species (such as CO
              <sub>2</sub>, CH<sub>4</sub>, etc.). &nbsp;The scale and
              composition of these emissions from land deterioration depend on
              factors such as vegetation cover, agricultural methodologies, and
              soil administration. The decline in soil quality demands the
              urgency to adopt sustainable land management techniques for
              agricultural activities and to pursue the restoration of degraded
              and depleted forests to enhance the reservoir of carbon (Lal 2003,
              p. 155).
            </p>
            <p>
              The modifications in land use and land cover (LULC) within forest
              ecosystems lead to significant changes in the composition and
              structure of a landscape (Noordwijk et al. 1997, p. 1999).
              Long-term alterations have resulted in the fragmentation of forest
              ecosystems, with the breaking of contiguous forests, which led to
              the depletion of biodiversity and modifications in the
              hydrological processes and biogeochemical cycles (Bharath et al.
              2014, p. 69).
            </p>
            <p>
              Significant carbon emission of about 43.5 PgC through land use
              change, evident from large-scale deforestation in south and
              southeast Asia. The decline in the forest biomass from 1850 to
              1990 from 76 PgC to 32 PgC contributed to 58% and 18% decrease in
              soil carbon. Global carbon emission of tropical Asia by 1995 was
              estimated to be approximately 7.7 PgC (out of 253 PgC),
              contributing to 3% from the combustion of fossil fuels, and around
              one-third emissions of 38.6 PgC out of 120 PgC by global land-use
              change (Houghton and Hackler 1999, p. 486). In India, the global
              carbon flux attributed to Land Use and Land Cover Change (LULCC)
              was estimated to be approximately 1.14 &plusmn; 0.18 Pg of carbon
              per year (Pg C yr-1) between 1990 and 2012 (Houghton et al. in
              2012, p. 5127). The net carbon emissions resulting from land use
              changes vary by region and range from 0 to 50 gCO2/kWh (grams of
              CO<sub>2</sub> per kilowatt-hour), with levels &lt;12 g/kWh (van
              de Ven et al., 2021, p. 1).
            </p>
            <p>
              Carbon emissions from forest ecosystems have shown consistency
              during the past two centuries, and estimated emissions of 3Gt CO
              <sub>2</sub> in 1850 have increased to 6Gt CO<sub>2</sub> in 2021.
              India holds the seventh position in contributing 3.4% of the
              cumulative total CO<sub>2</sub> emission and a more substantial
              contribution from land-use changes involving forest degradation
              and ranked slightly ahead of the UK, which accounts for 3.0% of
              the total emissions (IPCC 2021).
            </p>
            <p>
              The industrial revolution and subsequent globalization during the
              past century have given impetus to the uncontrolled increase in
              global atmospheric carbon emissions, aggravating impacts of
              changes in the climate change on natural resources like land,
              water, forest, soil, etc., which have made the policymakers
              worldwide focus on the carbon stocks of the Earth (Ramachandra and
              Bharath 2021, p. 53). Deforestation-induced temperature shifts
              lead to variations in the surface energy budget with changes in
              albedo, soil moisture, and land-atmosphere turbulent energy
              exchanges. Tropical deforestation, particularly large-scale
              clear-cutting, disrupts regional climate comparable to prolonged
              global warming in dire emissions scenarios, necessitating
              appropriate strategic policy interventions for safeguarding
              community welfare by maintaining ecosystem integrity with the
              sustainable management of fragile ecosystems (Zeppetello et al.
              2020, p. 6). Hence, comprehending land use and land cover (LULC)
              transformations and associated reduction in biomass and carbon
              storage is quintessential for formulating prudent management
              approaches to mitigate abrupt LULC changes to address challenges
              toward curtailing greenhouse gas emissions (Ramachandra and
              Bharath 2021, p. 54).
            </p>
            <p>
              Earth Observation systems have emerged as the primary source for
              methodically collecting repetitive and reliable spatial datasets
              for Global climate change, earth system modeling, natural resource
              management, food security, and biodiversity conservation (Roy et
              al. 2022, p. 1619). The availability of spatial data acquired
              regularly through remote sensors facilitates quantification of
              landscape dynamics, which aids in the assessment of status of
              forests, deforestation, and carbon stock, which plays a crucial
              role in decision-making processes at local, regional and national
              levels for the sustainable management of forests with the
              systematic alterations in land use (Roy et al. 2022, p. 1622;
              Ramachandra and Bharath 2020, p. 2754). InVEST&reg; (the Carbon
              Storage and Sequestration model, at
              &nbsp;https://naturalcapitalproject.stanford.edu/software/invest)
              helps in quantifying carbon stock and sequestration potential
              (Mengist et al. 2023, p. 5; Babbar et al. 2021, p. 2) through land
              use information with field data on four carbon pools (above-ground
              biomass (AGB), below-ground biomass (BGB), soil, and dead organic
              matter). Recent developments in Geoinformatics and the
              availability of multi-resolution remote sensing data, coupled with
              collateral data (compiled through field investigations), have
              gained prominence for estimating biomass, particularly in tropical
              forest ecosystems, which play a vital role in future biomass
              monitoring through AGB, BGB, and soil carbon (Eisfelder et al.
              2019, p. 2938) and quantification of changes in carbon footprint
              due to transitions in land uses.
            </p>
            <p>
              <strong>Objectives:</strong>
            </p>
            <p>
              The objectives of this study are (i) assessment of land use
              dynamics in the Chikamagaluru district of Karnataka during the
              past five decades, (ii) estimation of changes in forest structure
              through fragmentation matrices, (iii) evaluation of carbon
              sequestration in forest ecosystem through InVEST model and (iv)
              appraisal of impacts of land use changes on the regional climate.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
